import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/Icon';

/** @typedef {{
  icon: string,
  title: string,
  onClose: () => void
}} ModalHeaderProps */

/** @type { React.ValidationMap<ModalHeaderProps> } */
const propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

/** @type { React.FC<ModalHeaderProps> } */
const ModalHeader = props => {
  const { icon, title, onClose } = props;
  return (
    <div className="ModalHeader">
      <div className="flex px-6 py-4 justify-between items-center">
        <div className="flex items-center">
          <div className="p-2 bg-blue-200 text-blue-700 flex items-center justify-center rounded-full">
            <Icon name={icon} style={{ width: '1.5rem', height: '1.5rem' }} />
          </div>
          <div className="ml-4">
            <h4 className="text-gray-700 text-2xl">{title}</h4>
          </div>
        </div>
        <button
          className="flex hover:text-gray-700 items-center justify-center text-gray-500 text-xl"
          style={{
            fontSize: '1.25rem',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
          }}
          onClick={onClose}
        >
          <Icon name="x-circle" />
        </button>
      </div>
    </div>
  );
};

ModalHeader.propTypes = propTypes;

export { ModalHeader };
